import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const INVENTORY_URL = `${process.env.REACT_APP_BACKEND_URL_V2}/stock-layer`;

const initialState = {
  isLoading: false,
  error: null,
  items: [],
  transactions: [],
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getInventorySuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.items = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    getTransactionsSuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.transactions = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    clearTransactions(state) {
      state.transactions = [];
      state.error = null;
    },
  },
});

export default slice.reducer;

export function getInventory({ scopeId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(INVENTORY_URL, {
        params: { scopeId, page, limit },
      });
      dispatch(slice.actions.getInventorySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getInventoryTransactions({ productId, scopeId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${INVENTORY_URL}/${productId}/transactions`, {
        params: { scopeId, page, limit },
      });
      dispatch(slice.actions.getTransactionsSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export const { clearTransactions } = slice.actions;
